import { createContext, useContext, useState } from 'react';

type SearchHookResult = {
  queries: Map<number, string>;
  setQuery: (params: { id: number; value: string }) => void;
};

const SearchContext = createContext<SearchHookResult | undefined>(undefined);

type SearchProviderProps = {
  children: React.ReactNode;
};

export function SearchProvider({ children }: SearchProviderProps) {
  const [queries, setQueries] = useState<Map<number, string>>(new Map());

  function setQuery({ id, value }: { id: number; value: string }) {
    queries.set(id, value);

    setQueries(new Map(queries));
  }

  return <SearchContext.Provider value={{ queries, setQuery }}>{children}</SearchContext.Provider>;
}

export function useSpecificationsSearch() {
  const context = useContext(SearchContext);

  if (!context) {
    throw new Error('useSpecificationsSearch must be used within a SearchProvider');
  }

  return context;
}
